<template>
  <div class="container">
    <!-- logo栏 -->
    <div class="header w">
      <img class="logo" src="../../assets/logo.jpg" alt="" />
      <div class="search-box">
        <el-input placeholder="请输入关键字" v-model="keyword" clearable>
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
      </div>
    </div>
    <!-- 导航栏 -->
    <div class="nav">
      <div class="w nav-box">
        <router-link :to="{ path: item.url }" class="web-nav" v-for="(item, index) in navList" :key="index" @click="navChange(item.value)">{{ item.text }}</router-link>
      </div>
    </div>
    <!-- 轮播图 -->
    <div class="swipe">
      <el-carousel trigger="click">
        <el-carousel-item>
          <img src="https://ossimage.xiaochejun.cn/images/web/pic_1622439547692677.jpg" alt="" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="https://ossimage.xiaochejun.cn/images/web/pic_16224394282148793.jpg" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 网站内容 -->
    <router-view></router-view>
    <page-footer></page-footer>
  </div>
</template>

<script>
var navList = [
  { text: '网站首页', url: '/index/home' },
  { text: '关于我们', url: '/index/about' },
  { text: '产品展示', url: '/index/product' },
  { text: '技术文章', url: '/index/article' },
  { text: '成功案列', url: '/index/case' },
  { text: '联系我们', url: '/index/contact' }
]
export default {
  data() {
    return {
      keyword: '',
      navList: Object.assign([], navList),
      currentNav: 0
    }
  },
  created() {},
  methods: {
    search() {
      this.$store.commit('setKeyword', this.keyword)
      if (this.$route.meta.title != '文章列表') {
        this.$router.push({
          path: '/index/article/article-list'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo {
    height: 70px;
    object-fit: contain;
  }
  .search-box {
    width: 20%;
    height: 40px;
  }
}
.nav {
  width: 100%;
  background-color: #02328d;
  .nav-box {
    display: flex;
    .web-nav {
      flex: 1;
      height: 50px;
      line-height: 50px;
      color: #fff;
      text-align: center;
    }
    .web-nav:hover {
      background-color: #fff;
      color: #02328d;
    }
    .router-link-active {
      background-color: #fff;
      color: #02328d;
    }
  }
}
.swipe {
  //   height: 200px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
